export const USER_CREATE_REQUEST = "REGISTER/USER_CREATE_REQUEST";
export const USER_CREATE_SUCCESS = "REGISTER/USER_CREATE_SUCCESS";
export const USER_CREATE_FAILURE = "REGISTER/USER_CREATE_FAILURE";

export const RESEND_EMAIL_REQUEST = "REGISTER/RESEND_EMAIL_REQUEST";
export const RESEND_EMAIL_SUCCESS = "REGISTER/RESEND_EMAIL_SUCCESS";
export const RESEND_EMAIL_FAILURE = "REGISTER/RESEND_EMAIL_FAILURE";


// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Register/constants.js